module.exports = __webpack_public_path__ + "tea_box_mockup_design_packaging_herbal_josif_pancic_moc_bilja.jpg?0f43b076955127ccf7619a9ffd47bc91";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/tea_box_mockup_design_packaging_herbal_josif_pancic_moc_bilja.jpg
// module id = 83
// module chunks = 0